import React, { memo, useCallback } from 'react';

import { Button } from '@mui/material';
import { EditPenIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { EDIT_BUTTON_LABEL } from '../../LoanCicHistory.constants';

import { editButtonStyles } from './CicEditChangeButton.styles';

const CicEditChangeButton = ({ change, dataTestId, onEdit }) => {
  const onClick = useCallback(() => onEdit(change), [onEdit, change]);

  return (
    <Button
      data-testid={dataTestId}
      size="small"
      startIcon={<EditPenIcon size={IconSize[16]} />}
      sx={editButtonStyles}
      variant="text"
      onClick={onClick}
    >
      {EDIT_BUTTON_LABEL}
    </Button>
  );
};

CicEditChangeButton.propTypes = {
  change: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
  dataTestId: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default memo(CicEditChangeButton);
